// Helpers for token storage and expiry checks
const ACCESS_TOKEN_KEY = 'accessToken';
const AUTH_USER_KEY = 'authUser';

export function getToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || null;
}

export function saveToken(token) {
  if (!token) return;
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function getStoredAuthUser() {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveStoredAuthUser(user) {
  if (!user || typeof user !== 'object') return;
  try {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  } catch {
    // ignore storage failures
  }
}

export function clearStoredAuthUser() {
  try {
    localStorage.removeItem(AUTH_USER_KEY);
  } catch {
    // ignore storage failures
  }
}

export function clearBrowserStorage() {
  try {
    localStorage.clear();
  } catch {
    // ignore storage failures during cleanup
  }

  try {
    sessionStorage.clear();
  } catch {
    // ignore storage failures during cleanup
  }
}

function base64UrlDecode(str) {
  try {
    // replace URL-safe chars
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    // pad with '='
    const pad = base64.length % 4;
    const padded = base64 + (pad ? '='.repeat(4 - pad) : '');
    const decoded = atob(padded);
    // handle UTF-8
    try {
      return decodeURIComponent(
        decoded
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
    } catch (e) {
      console.log(e);
      return decoded;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
}

export function parseJwt(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  const payload = base64UrlDecode(parts[1]);
  if (!payload) return null;
  try {
    return JSON.parse(payload);
  } catch (e) {
    console.log(e);
    return null;
  }
}

export function isTokenExpired(token) {
  const parsed = parseJwt(token);
  // If we can't parse the token or it lacks an `exp` claim, treat it as expired.
  if (!parsed || !parsed.exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return parsed.exp <= now;
}

export default {
  getToken,
  saveToken,
  clearToken,
  getStoredAuthUser,
  saveStoredAuthUser,
  clearStoredAuthUser,
  clearBrowserStorage,
  parseJwt,
  isTokenExpired,
};
